<h2>
  {{ 'LICENCE_CHECKING.licenceCategory' | translateOrFallback:'Licence Category' }}
  <ng-container *ngIf="licenceType"><strong>({{ licenceType }})</strong></ng-container>
</h2>

<vrm-basic-table [data]="dataSource" [columns]="columns">

  <ng-container matColumnDef="commenceDate">
    <th width="100" mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.commenceDate' | translateOrFallback:'Commence Date' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.commenceDate }}</td>
  </ng-container>

  <ng-container matColumnDef="expiryDate">
    <th width="100" mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.expiryDate' | translateOrFallback:'Expiry Date' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.expiryDate }}</td>
  </ng-container>

  <ng-container matColumnDef="offenceCode">
    <th width="100" mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.offenceCode' | translateOrFallback:'Offence Code' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.offenceCode }}</td>
  </ng-container>

  <ng-container matColumnDef="identifier">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.identifier' | translateOrFallback:'Identifier' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.identifier }}</td>
  </ng-container>

  <ng-container matColumnDef="restrictionCodes">
    <th width="120" mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.restrictionCodes' | translateOrFallback:'Restriction Codes' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.restrictionCodes }}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.description' | translateOrFallback:'Description' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.description }}</td>
  </ng-container>
</vrm-basic-table>
